// import Icon from "../Icon";
// import LinkComp from "../LinkComp";
// import * as React from "react";

// export default ({pipelineLinks, name, isSidebarOpen, isPipelineOpen, svg, path, handleCollapsePipeline, onLinkHover}) => {
//     const isAnyPipelineActive = pipelineLinks.find(el => el.url === path);
//     return (
//         <React.Fragment>
//             <li className={`Sidebar_item strive-pipeline first-strive-pipeline ${isPipelineOpen ? "" : "closed-first-strive-pipeline"}`}
//                 onMouseOver={onLinkHover}>
//                 <div className="item-wrapper">
//                     <div className={`Sidebar_item_link ${isAnyPipelineActive ? "Sidebar_item_link--active" : ""}`}
//                          onClick={handleCollapsePipeline}>
//                         <Icon svg={svg}/>
//                         <div className="Sidebar_item_link_name uppercase">{name}</div>
//                     </div>
//                     {
//                         isSidebarOpen ?
//                             null
//                             :
//                             <span className="tooltip uppercase">{name}</span>
//                     }
//                 </div>
//             </li>
//             {
//                 pipelineLinks.map((link, index) => (
//                     <li className={`Sidebar_item strive-pipeline ${index === pipelineLinks.length - 1 ? "last-strive-pipeline" : ""} ${isPipelineOpen ? "" : "closed-strive-pipeline"}`}
//                         key={index}
//                         onMouseOver={onLinkHover}>
//                         <div className="item-wrapper">
//                             <LinkComp className={`Sidebar_item_link ${isSidebarOpen ? "" : "closed-sidebar"}${link.url === path ? " Sidebar_item_link--active" : ""}`}
//                                       to={arc.path.base + link.url}>
//                                 <Icon svg={link.svg}/>
//                                 <div className="Sidebar_item_link_name">{link.name}</div>
//                             </LinkComp>
//                             {
//                                 isSidebarOpen ?
//                                     null
//                                     :
//                                     <span className="tooltip">{link.name}</span>
//                             }
//                         </div>
//                     </li>
//                 ))
//             }
//         </React.Fragment>
//     )
// }



import Icon from "../Icon";
import LinkComp from "../LinkComp";
import * as React from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import plus from '../../svgs/plus-dark.svg';

export default ({
  pipelineLinks,
  name,
  isSidebarOpen,
  isPipelineOpen,
  svg,
  path,
  handleCollapsePipeline,
  onLinkHover,
  onMouseCrmEnter
}) => {
const actualPath = path.startsWith("contacts/") ? path : `contacts/${path}`;
const isAnyPipelineActive = pipelineLinks.find((el) => el.url === actualPath);

  return (
    <React.Fragment>
      <li
        className={`Sidebar_item strive-pipeline first-strive-pipeline ${
          isPipelineOpen ? "" : "closed-first-strive-pipeline"
        }`}
        onMouseOver={onLinkHover}
      >
        <div className="item-wrapper" style={{width:"250px"}}>
          <div 
            className={`Sidebar_item_link ${
              isAnyPipelineActive ? "Sidebar_item_link--active" : ""
            }`}
            onClick={handleCollapsePipeline}
          >
            <Icon  svg={svg}  />
            <div className="Sidebar_item_link_name uppercase">{name}</div>
            {/* Dropdown toggle icon with inline styling */}
            <div onMouseEnter={onMouseCrmEnter}
              className="dropdown-icon"
              style={{
                marginLeft: "auto", // Push to the far right
                marginRight: "8px", // Add space on the right
                display: "flex",
                alignItems: "center",
              }}
            >
              {isPipelineOpen ? <FaChevronDown /> : <FaChevronRight />}
            </div>
          </div>
          {isSidebarOpen ? null : <span className="tooltip uppercase">{name}</span>}
        </div>
      </li>
      {pipelineLinks.map((link, index) => (
        <li
          className={`Sidebar_item strive-pipeline ${
            index === pipelineLinks.length - 1
              ? "last-strive-pipeline"
              : ""
          } ${isPipelineOpen ? "" : "closed-strive-pipeline"}`}
          key={index}
          onMouseOver={onLinkHover}
        >
          <div className="item-wrapper" style={{width:"250px"}}>
            <LinkComp
              className={`Sidebar_item_link ${
                isSidebarOpen ? "" : "closed-sidebar"
              }${link.url === path ? " Sidebar_item_link--active" : ""}`}
              to={arc.path.base + link.url}
            >
              <Icon svg={link.svg} />
              <div className="Sidebar_item_link_name">{link.name}</div>
            </LinkComp>
            {isSidebarOpen ? null : <span className="tooltip">{link.name}</span>}
{link.newPath && (
  <LinkComp
  className="New-btn-crm"
  onClick={()=>{ 
  sessionStorage.setItem("isCrmback", `${link.newPath}|${link.url}`);
  } }
    to={arc.path.base + link.newPath}
style={{
     marginTop:"12px",
      width: "17px",
      height: "17px",
      borderRadius: "3px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      // color: "grey",
      background: "transparent",
      padding: "0",
      cursor: "pointer",
      textDecoration: "none",
      marginLeft: link.name === "Team Members" ? "-8px" : "0px", // 👈 tweak here
      marginRight:"-11px"
    }}
  >
    <Icon svg={plus} />
  </LinkComp>
)}
          </div>
        </li>
      ))}
    </React.Fragment>
  );
};
